document.querySelectorAll('.card-feature').forEach(card => {
  const toggle = card.querySelector('.card-feature__toggle');

  card.addEventListener('mousemove', e => {
    if (window.innerWidth <= 960) return;

    if (!toggle.classList.contains('is-active')) {
      toggle.classList.add('is-active');
      card.style.cursor = 'none';
    }

    const rect = toggle.getBoundingClientRect();
    const halfW = rect.width / 2;
    const halfH = rect.height / 2;

    toggle.style.left = `${e.clientX - halfW}px`;
    toggle.style.top = `${e.clientY - halfH}px`;
  });

  card.addEventListener('mouseleave', () => {
    toggle.classList.remove('is-active');
    toggle.style.left = '';
    toggle.style.top = '';
    card.style.cursor = '';
  });
});

window.addEventListener('resize', () => {
  if (window.innerWidth <= 960) {
    document.querySelectorAll('.card-feature__toggle').forEach(toggle => {
      toggle.classList.remove('is-active');
      toggle.style.left = '';
      toggle.style.top = '';
    });
    document.querySelectorAll('.card-feature').forEach(card => {
      card.style.cursor = '';
    });
  }
});

document.querySelectorAll('.card-feature').forEach(cardFeature => {
  const cards = Array.from(cardFeature.querySelectorAll('.card-feature__copy'));
  if (cards.length < 2) return;

  const delay = 500;
  let canClick = true;

  // стартові z-index
  cards.forEach((c, i) => {
    c.style.zIndex = i + 1;
  });

  cardFeature.addEventListener('click', () => {
    if (!canClick) return;
    canClick = false;

    const topCard = cards.reduce(
      (max, c) =>
        parseInt(c.style.zIndex) > parseInt(max.style.zIndex) ? c : max,
      cards[0]
    );

    // Верхня картка їде на задній план
    topCard.classList.add('to-right');
    setTimeout(() => {
      topCard.style.zIndex = 1;
    }, delay / 2);

    // Інші картки отримують to-left
    cards.forEach(c => {
      if (c !== topCard) {
        c.classList.add('to-left');
        setTimeout(() => {
          c.style.zIndex = parseInt(c.style.zIndex) + 1;
        }, delay / 2);
      }
    });

    // прибираємо анімаційні класи після delay
    setTimeout(() => {
      topCard.classList.remove('to-right');
      cards.forEach(c => c.classList.remove('to-left'));
    }, delay);

    setTimeout(() => {
      canClick = true;
    }, delay * 2);
  });
});
